import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getYearsWithData } from "../../apis/revshare/ReportsApi";
import { Col, Container, Form, Row } from "react-bootstrap";
import FormRow from "../common/forms/FormRow";
import SelectInput from "../common/forms/SelectInput";
import SubAccountsByMonthGrid from "./SubAccountsByMonthGrid";

export default function SubAccountsByMonthReport(props) {
  
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);

  const yearChange = (event) => {
    setYear(parseInt(event.target.value));
  };

  const getYears = () => {
    let data = getYearsWithData();
    return data;
  }

  useEffect(() => {
    getYears()
    .then((years) => setYears(years))
    .catch((error) => {
      throw error;
    });
  }, []);

  const selectRef = React.createRef();

  return (
    <Container fluid>
      <Row>
        <Form>
          <FormRow
            columns={[
              <SelectInput
                default={year.toString()}
                label="Year"
                onChange={yearChange}
                options={years}
                ref={selectRef}
              />,
            ]}
          />
        </Form>
      </Row>
      <Row>
        <Col>
          <SubAccountsByMonthGrid isManager={props.isManager} year={year} />
        </Col>
      </Row>
    </Container>
  );
}

SubAccountsByMonthReport.propTypes = {
  isManager: PropTypes.bool,
};